export enum NeedFixPersonalAndAdressInfo {
  ERROR_711 = 711,
  ERROR_803 = 803,
  ERROR_804 = 804,
  ERROR_805 = 805,
  ERROR_808 = 808,
  ERROR_750 = 750,
}

export enum NeedFixAdressInfo {
  ERROR_807 = 807,
}
